import { useTranslation } from 'react-i18next';

import { Form, FormGenerator } from '@/shared/ui';
import { FormFieldValues } from '@/shared/ui/FormGenerator';
import { SvgIcon } from '@/shared/ui/SvgIcon';

import { changeChannelNameFormDataSchema } from '../../model/schemas';
import { TChangeChannelNameFormData } from '../../model/types';
import { useChannelName } from '../../model/useChannelName';

import {
  StyledButton,
  StyledFormContainer,
} from './styles/changeChannelNameFormStyles';

type ChangeChannelNameFormProps = {
  channelId: string;
  defaultName?: string;
};

const CHANGE_CHANNEL_NAME_FORM_ID = 'change-channel-name-form';

export const ChangeChannelNameForm = ({
  channelId,
  defaultName = '',
}: ChangeChannelNameFormProps) => {
  const { t } = useTranslation();
  const { setChannelNameMutation } = useChannelName();

  const { updateChannelName, isPending } = setChannelNameMutation;

  const handleSubmit = async (data: TChangeChannelNameFormData) => {
    await updateChannelName({
      channelId,
      name: data.name.trim(),
    });
  };

  const formScheme = [
    {
      name: 'name',
      label: t('channels:settings.inputs.channelName.label'),
      type: FormFieldValues.Default,
      inputProps: {
        endAdornment: <SvgIcon name="edit-2" color="primary" />,
      },
    },
  ];

  return (
    <StyledFormContainer direction="row" gap={4} alignItems="end">
      <Form
        id={CHANGE_CHANNEL_NAME_FORM_ID}
        schema={changeChannelNameFormDataSchema(t)}
        onSubmit={handleSubmit}
        defaultValues={{ name: defaultName }}
        mode="onChange"
        sx={{ maxWidth: '277px' }}
      >
        <FormGenerator formScheme={formScheme} />
      </Form>
      <StyledButton
        variant="contained"
        type="submit"
        form={CHANGE_CHANNEL_NAME_FORM_ID}
        size="medium"
        loading={isPending}
      >
        {t('common:buttons.save')}
      </StyledButton>
    </StyledFormContainer>
  );
};
